module.exports = __webpack_public_path__ + "img/Logo-Grupo-NSC-09.5481f1a5.png";